var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"context_box",attrs:{"srcdoc":_vm.preview_context,"frameborder":"0","width":"100%","height":"100%"}})}
var staticRenderFns = []

export { render, staticRenderFns }